
import { Component } from 'vue-property-decorator'
import BaseLayout from '@/shared/components/BaseLayout.vue'
import { Action, Getter } from 'vuex-class'
import WarehousesDto from '@/api/dto/WarehousesDto'
import WarehousesMapping from '@/api/models/WarehousesMapping'
import StorageMixin from '@/shared/mixins/StorageMixin.vue'

@Component({
    components: {
        BaseLayout
    },
    mixins: [StorageMixin]
})

export default class Warehouses extends BaseLayout {
    private readonly STATE = {
        DEFAULT: 'default',
        LOADING: 'loading'
    }

    @Getter('warehouses')
    warehouses!: Array<WarehousesMapping>

    @Action('loadWarehousesMapping')
    loadWarehousesMapping!: () => Promise<void>

    @Action('saveWarehousesMapping')
    saveWarehousesMapping!: (mapping: WarehousesDto) => Promise<void>

    private errors: { [key: string]: string } = {}

    private loadAnimate = this.STATE.DEFAULT

    async created (): Promise<void> {
        await this.handleCallback(async () => {
            await this.loadWarehousesMapping()
        })
    }

    async save (): Promise <void> {
        this.validate()

        if (!Object.keys(this.errors).length) {
            this.loadAnimate = this.STATE.LOADING
            const dto: WarehousesDto = {
                warehouses: this.warehouses
            }

            await (this.$refs.baseLayout as BaseLayout).handleWithAlerts(async () => {
                await this.saveWarehousesMapping(dto)
            }, this.$t('warehousesMapping.success').toString())

            this.loadAnimate = this.STATE.DEFAULT
        }
    }

    private validate () {
        this.errors = {}
        for (const warehouse of this.warehouses) {
            if (warehouse.yamWarehouseId !== null && !(/^[0-9]*$/.test(warehouse.yamWarehouseId))) {
                this.errors[warehouse.crmCode] = this.$t('warehousesMapping.errorFormat').toString()
            }
        }
    }
}
